import { Author } from './authors';

export interface Article {
  addendum?: string;
  authors: Author[];
  commentCount?: number;
  commenters?: string[];
  contentType: 'Article';
  freeBlurb: string;
  frontCoverPhoto?: string;
  fullText: string;
  highlight: string;
  id: number;
  isPro: boolean;
  media?: Media;
  newsletter?: string;
  pickups?: Pickup[];
  picture?: string;
  pictureCaption?: string;
  publishedAt: string;
  slug: string;
  subTitle?: string;
  takeaway?: string;
  title: string;
}

export interface ArticlePickup {
  slug: string;
  title: string;
  pickups: Omit<Pickup, 'author'>[];
}

export type MostPopularArticle = Pick<
  Article,
  'id' | 'title' | 'slug' | 'highlight' | 'publishedAt'
>;

export interface Briefing {
  body: string;
  contentType: 'Briefing';
  createdAt: string;
  headline: string;
  id: number;
  authors: Author[];
  slug: string;
}

export interface CommunityComment {
  author: Author;
  excerpt: string;
  id: number;
  title: string;
  url: string;
}

export interface FeaturedPartner {
  name: string;
  tagline: string;
  targetLink: string;
}

export interface FeedUnit {
  content: Article[] | ForumPost[];
  unitDescription?: string;
  unitName: UnitName;
  viewAllUrl: string;
}

export type FeedUnits = {
  [slotIndex: number]: FeedUnit;
};

export interface ForumPost {
  id: number;
  title: string;
  author: Author;
}

export type LatestProArticles = Pick<Article, 'title' | 'slug' | 'highlight' | 'publishedAt'>;

export interface Media {
  description: string;
  embed_code?: string;
  id: number;
  img?: {
    url?: string;
  };
  preview: string;
  public: boolean;
  theme: string;
  title: string;
  video?: {
    url?: string;
  };
}

export interface Newsletter {
  author: string;
  description: string;
  id: number;
  isLoggedIn: boolean;
  isSubscribed: boolean;
  name: string;
}

export interface Pickup {
  author?: string;
  id: number;
  publication?: string;
  title: string;
  url: string;
}

export enum UnitName {
  CreatorEconomy = 'Creator Economy',
  Forum = 'Trending on forum',
  LatestNewsletters = 'Latest Newsletters',
  TheWeekend = 'The Weekend',
}

export interface UpcomingEvent {
  slug: string;
  name: string;
  location: string;
  date: string;
}
